export default __webpack_public_path__ + "static/media/galery_photo1@2x.f6c3a135.png";